import { render, staticRenderFns } from "./UpdatePicture.vue?vue&type=template&id=2dfddc84&"
import script from "./UpdatePicture.vue?vue&type=script&lang=js&"
export * from "./UpdatePicture.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports